module.exports = __webpack_public_path__ + "static/aboutme-e5e26347a7e0f1d29d0eaeed3e27b0a3.svg";